import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { Link, Redirect } from "react-router-dom";
import { DEBUG_STATE } from "../../constants/constants.js"
import ReactTooltip from "react-tooltip";
import { unstable_renderSubtreeIntoContainer } from "react-dom";

function OrgEdit(props) {
  const { org, editOrg, getOrgTypes, getOrgDetail, setCurrentOrgId } = props;
  const org_detail = org.org_detail;
  const org_id = props.match.params.id;
  const orgTypes = org?.org_types ? org.org_types : [];

  const editRequest = org?.editRequest;


  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;

  const debug = DEBUG_STATE;

  const [orgRequest, setOrgRequest] = useState({});
  const [orgType, setOrgType] = useState(org_detail?.org_type);
  const [allowManifest, setAllowManifest] = useState((org_detail?.jotform_code ? true : false));
  const [allowShipping, setAllowShipping] = useState((org_detail?.allow_shipping_label ? true : false));
  const [shippingProvider, setShippingProvider] = useState((org_detail?.shipping_provider));
  const [allowUpload, setAllowUpload] = useState((org_detail?.allow_upload ? true : false));
  const [allowDocTypes, setAllowDocTypes] = useState((org_detail?.allow_doc_types ? true : false));
  const [allowAddons, setAllowAddons] = useState((org_detail?.allow_addons ? true : false));
  const [allowClassification, setAllowClassification] = useState((org_detail?.allow_classification ? true : false));
  const [allowFileSplitting, setAllowFileSplitting] = useState((org_detail?.allow_file_splitting ? true : false));

  useEffect(() => {
    setCurrentOrgId(org_id);
    getOrgDetail(org_id);
  }, [org_id])

  useEffect(() => {
    if (org_detail !== null) {
      let tmpOrg = {};
      Object.assign(tmpOrg, org_detail);
      setOrgRequest(tmpOrg);
      if (debug) {
        console.log(orgRequest);
        console.log("allow shipping: " + allowShipping);
      }

    }
  }, [org_detail]);

  useEffect(() => {
    if (orgTypes.length === 0) getOrgTypes();
  }, [orgTypes]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!allowManifest) {
      orgRequest["jotform_code"] = "";
    }

    orgRequest["allow_shipping_label"] = allowShipping;
    if (!allowShipping) {
      orgRequest["street_1"] = "";
      orgRequest["street_2"] = "";
      orgRequest["city"] = "";
      orgRequest["state"] = "";
      orgRequest["zip"] = "";
      orgRequest["contact_email"] = "";
      orgRequest["contact_phone"] = "";
    }

    orgRequest["org_type"] = orgType;
    orgRequest["shipping_provider"] = shippingProvider;
    orgRequest["allow_doc_types"] = allowDocTypes;
    orgRequest["allow_upload"] = allowUpload;
    orgRequest["allow_addons"] = allowAddons;
    orgRequest["allow_classification"] = allowClassification;
    orgRequest["allow_file_splitting"] = allowFileSplitting;
    if (debug) {
      console.log(orgRequest);
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    editOrg(orgRequest);
  };

  const setDisplayName = (e) => {
    const { name, value } = e.target;
    orgRequest["display_name"] = value;
  };

  const setLegalName = (e) => {
    const { name, value } = e.target;
    orgRequest["legal_name"] = value;
  };

  const orgTypeChange = (event) => {
    setOrgType(event.target.value);
  };

  const setOrgEmail = (e) => {
    const { name, value } = e.target;
    orgRequest["org_email"] = value;
  };

  const setOrgPhone = (e) => {
    const { name, value } = e.target;
    orgRequest["org_phone"] = value;
  };

  const handleChangeAllowManifest = () => {
    setAllowManifest(!allowManifest);
  };

  const setJotformCode = (e) => {
    const { name, value } = e.target;
    orgRequest["jotform_code"] = value;
  };

  const handleChangeAllowShipping = () => {
    setAllowShipping(!allowShipping);
  };

  const shippingProviderChange = (e) => {
    setShippingProvider(e.target.value);
  }
  const setStreet1 = (e) => {
    const { name, value } = e.target;
    orgRequest["street_1"] = value;
  };

  const setStreet2 = (e) => {
    const { name, value } = e.target;
    orgRequest["street_2"] = value;
  };

  const setCity = (e) => {
    const { name, value } = e.target;
    orgRequest["city"] = value;
  };

  const setState = (e) => {
    const { name, value } = e.target;
    orgRequest["state"] = value;
  };

  const setZip = (e) => {
    const { name, value } = e.target;
    orgRequest["zip"] = value;
  };

  const setShippingContactEmail = (e) => {
    const { name, value } = e.target;
    orgRequest["contact_email"] = value;
  };

  const setShippingContactPhone = (e) => {
    const { name, value } = e.target;
    orgRequest["contact_phone"] = value;
  };

  const handleChangeAllowUpload = () => {
    setAllowUpload(!allowUpload);
  };

  const handleChangeAllowDocTypes = () => {
    setAllowDocTypes(!allowDocTypes);
  };

  const handleChangeAllowAddons = () => {
    setAllowAddons(!allowAddons);
  };

  const handleChangeAllowClassification = () => {
    setAllowClassification(!allowClassification);
  };

  const handleChangeAllowFileSplitting = () => {
    setAllowFileSplitting(!allowFileSplitting);
  };

  const setModelName = (e) => {
    const { name, value } = e.target;
    orgRequest["model_name"] = value;
  };

  if (editRequest === 'completed') {
    return (
      <Redirect
        to={{
          pathname: "/org/" + org_detail?.org_id,
          state: { org_detail: orgRequest },
        }}
      />
    )
  }
  return (

    <div className="searchMain">
      <div className="contentContainerLeftNav">
        <div className="rightContent">
          <h3>
            {org_detail?.display_name}
            &nbsp;&nbsp;&nbsp;
            <span className="h3SubSpan">(editing)</span>
            &nbsp;&nbsp;&nbsp;
            <div className="editJacketNameIcon" data-tip data-for="cancel">
              <Link
                to={{
                  pathname: "/org/" + org_detail?.org_id,
                  state: { org_detail: org_detail },
                }}
              >
                <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
              </Link>
            </div>
            &nbsp;&nbsp;&nbsp;
            <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
              cancel
            </ReactTooltip>
            <div className="editJacketNameIcon" data-tip data-for="save" >
              <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
            </div>
            <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
              save
            </ReactTooltip>
          </h3>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Contact
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Display Name</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="display_name"
                      name="display_name"
                      type="text"
                      defaultValue={org_detail?.display_name}
                      onChange={setDisplayName}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Legal Name</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="legal_name"
                      name="legal_name"
                      type="text"
                      defaultValue={org_detail?.legal_name}
                      onChange={setLegalName}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel"><span className="requiredAsterisk">*</span>Type</td>
                  <td className="formInfo">
                    <select
                      id="org_type"
                      value={orgType === null ? orgTypes[0] : orgType}
                      onChange={orgTypeChange}
                    >
                      {orgTypes?.map((type, i) => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Parent Org</td>
                  <td className="formInfo">{org_detail?.parent_org_name}

                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Email</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="org_email"
                      name="org_email"
                      type="text"
                      defaultValue={org_detail?.org_email}
                      onChange={setOrgEmail}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Phone</td>
                  <td className="formInfo">
                    <input
                      style={{ width: "100%" }}
                      id="org_phone"
                      name="org_phone"
                      type="text"
                      defaultValue={org_detail?.org_phone}
                      onChange={setOrgPhone}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Manifest
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Manifest?</td>
                  <td className="formInfo">
                    {
                      allowManifest && (<input type="checkbox" checked onChange={handleChangeAllowManifest} />)
                    }
                    {
                      !(allowManifest) && (<input type="checkbox" onChange={handleChangeAllowManifest} />)
                    }
                  </td>
                </tr>

                {allowManifest && (
                  <>
                    <tr>
                      <td className="formLabel"><span className="requiredAsterisk">*</span>Jotform URL</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="joform_code"
                          name="jotform_code"
                          autoComplete="off"
                          defaultValue={org_detail?.jotform_code}
                          onChange={setJotformCode}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel"></td>
                      <td className="formInfo">
                        <a href={org_detail?.jotform_code} target="_blank">view manifest</a>
                      </td>
                    </tr>
                  </>
                )}

              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Shipping
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Shipping Label?</td>
                  <td className="formInfo">
                    {
                      allowShipping && (<input type="checkbox" checked onChange={handleChangeAllowShipping} />)
                    }
                    {
                      !(allowShipping) && (<input type="checkbox" onChange={handleChangeAllowShipping} />)
                    }
                  </td>
                </tr>
                {
                  (allowShipping) && (
                    <>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Provider</td>
                        <td className="formInfo">
                          <select className="orgTypeDropdown"
                            id="shipping_provider"
                            value={shippingProvider === null ? "fedex_2_day" : shippingProvider}
                            onChange={shippingProviderChange}
                          >
                            <option key={'fedex_2_day'} value={'fedex_2_day'}>fedex_2_day</option>
                            <option key={'ups_second_day_air'} value={'ups_second_day_air'}>ups_second_day_air</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" className="formLabelCentered">
                          <b>Shipping Address</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>street address (line 1)</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="street_1"
                            name="street_1"
                            autoComplete="off"
                            defaultValue={org_detail?.street_1}
                            onChange={setStreet1}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel">street address (line 2)</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="street_2"
                            name="street_2"
                            autoComplete="off"
                            defaultValue={org_detail?.street_2}
                            onChange={setStreet2}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>City</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="city"
                            name="city"
                            autoComplete="off"
                            defaultValue={org_detail?.city}
                            onChange={setCity}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>state</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="state"
                            name="state"
                            autoComplete="off"
                            defaultValue={org_detail?.state}
                            onChange={setState}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>zip</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            defaultValue={org_detail?.zip}
                            onChange={setZip}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Contact Email</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            defaultValue={org_detail?.contact_email}
                            onChange={setShippingContactEmail}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="formLabel"><span className="requiredAsterisk">*</span>Shipping Contact Phone</td>
                        <td className="formInfo">
                          <input
                            style={{ width: "100%" }}
                            id="zip"
                            name="zip"
                            autoComplete="off"
                            defaultValue={org_detail?.contact_phone}
                            onChange={setShippingContactPhone}
                          />
                        </td>
                      </tr>
                    </>
                  )}
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Upload
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Self-Serve Upload?</td>
                  <td className="formInfo">
                    {
                      (allowUpload) && (<input type="checkbox" checked onChange={handleChangeAllowUpload} />)
                    }
                    {
                      !(allowUpload) && (<input type="checkbox" onChange={handleChangeAllowUpload} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Doc Type Permissioning?</td>
                  <td className="formInfo">
                    {
                      allowDocTypes && (<input type="checkbox" checked onChange={handleChangeAllowDocTypes} />)
                    }
                    {
                      !(allowDocTypes) && (<input type="checkbox" onChange={handleChangeAllowDocTypes} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Self-Serve Addons?</td>
                  <td className="formInfo">
                    {
                      allowAddons && (<input type="checkbox" checked onChange={handleChangeAllowAddons} />)
                    }
                    {
                      !(allowAddons) && (<input type="checkbox" onChange={handleChangeAllowAddons} />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Classification Pipeline?</td>
                  <td className="formInfo">
                    {
                      allowClassification && (<input type="checkbox" checked onChange={handleChangeAllowClassification} />)
                    }
                    {
                      !(allowClassification) && (<input type="checkbox" onChange={handleChangeAllowClassification} />)
                    }
                  </td>
                </tr>
                {
                  allowClassification && (
                    <tr>
                      <td className="formLabel">Classification Model</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="model_name"
                          name="model_name"
                          autoComplete="off"
                          defaultValue={org_detail?.model_name}
                          onChange={setModelName}
                        />
                      </td>
                    </tr>
                  )}
                <tr>
                  <td className="formLabel">Allow File Splitting?</td>
                  <td className="formInfo">
                    {
                      allowFileSplitting && (<input type="checkbox" checked onChange={handleChangeAllowFileSplitting} />)
                    }
                    {
                      !(allowFileSplitting) && (<input type="checkbox" onChange={handleChangeAllowFileSplitting} />)
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <div className="cancelSaveFooter">
            <span className="h3SubSpan">(editing)</span>
            &nbsp;&nbsp;&nbsp;
            <div className="editJacketNameIcon" data-tip data-for="cancel">
              <Link
                to={{
                  pathname: "/org/list",
                }}
              >
                <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
              </Link>
            </div>
            &nbsp;&nbsp;&nbsp;
            <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
              cancel
            </ReactTooltip>
            <div className="editJacketNameIcon" data-tip data-for="save" >
              <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
            </div>
            <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
              save
            </ReactTooltip>
          </div>
        </div>
      </div>
    </div>

  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  resetOrgEdit: orgActions.resetOrgEdit,
  editOrg: orgActions.editOrg,
  getOrgTypes: orgActions.getOrgTypes,
  getOrgDetail: orgActions.getOrgDetail,
  setCurrentOrgId: orgActions.setCurrentOrgId
};

const connectedOrgEdit = connect(mapStateToProps, actionCreators)(OrgEdit);
export { connectedOrgEdit as OrgEdit };
